import React, { memo } from "react";
import classNames from "classnames";

import "./feedbackScale.scss";

type FeedbackScaleProps = {
  value?: number | null;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  leftLabel: string;
  rightLabel: string;
  className?: string;
  disabled?: boolean;
};

export const FeedbackScale = memo(function FeedbackScale({
  value = null,
  onChange,
  min = 1,
  max = 5,
  leftLabel,
  rightLabel,
  className,
  disabled = false,
}: FeedbackScaleProps) {
  const items = Array.from(
    { length: max - min + 1 },
    (_, index) => min + index
  );

  return (
    <div
      className={classNames("feedback-scale", className)}
      style={
        {
          "--feedback-scale-columns": items.length,
        } as React.CSSProperties
      }
    >
      <div className="feedback-scale__row" role="radiogroup">
        {items.map((item) => {
          const isActive = value === item;

          return (
            <button
              key={item}
              type="button"
              role="radio"
              aria-checked={isActive}
              onClick={() => !disabled && onChange(item)}
              disabled={disabled}
              aria-label={`Rate ${item}`}
              className={classNames(
                "feedback-scale__button",
                isActive && "feedback-scale__button--active"
              )}
            >
              {item}
            </button>
          );
        })}
      </div>

      <div className="feedback-scale__labels">
        <span className="feedback-scale__label">{leftLabel}</span>
        <span className="feedback-scale__label">{rightLabel}</span>
      </div>
    </div>
  );
});
